export default __webpack_public_path__ + "static/media/PAFI_LKTT 2019.2b919bcc.pdf";